import React, { useState } from 'react';

import { Container, ContentWrapper, Header, Title } from './MyLeads.styles';
import KanbanBoard from './components/KanbanBoard';
import StatsCards from './components/StatsCards';
import Tabs from './components/Tabs';

const initialColumns = {
  new: [
    {
      id: '1',
      companyName: 'First Telecom',
      phoneNumber: '+374 11 123456',
      address: 'Zakayan 57/12, Yerevan',
      assignedTo: 'Aghavan Dashtsyan',
      priority: 'New',
      status: 'new',
    },
    {
      id: '2',
      companyName: 'StartUp Hub Armenia',
      phoneNumber: '+374 10 566777',
      address: 'Komitas 55, Yerevan',
      assignedTo: 'Aghavan Dashtsyan',
      priority: 'High',
      status: 'new',
    },
  ],
  contacted: [
    {
      id: '3',
      companyName: 'Tech Solutions LLC',
      phoneNumber: '+374 10 998877',
      address: 'Mashtots Ave 33, Yerevan',
      assignedTo: 'Aghavan Dashtsyan',
      priority: 'High',
      status: 'contacted',
    },
  ],
  negotiation: [
    {
      id: '4',
      companyName: 'Avan Grigoryan',
      phoneNumber: '+374 77 223344',
      address: 'Abovyan 52, Yerevan',
      assignedTo: 'Aghavan Dashtsyan',
      priority: 'High',
      status: 'negotiation',
    },
  ],
  closedWon: [
    {
      id: '5',
      companyName: 'Digital Media Group',
      phoneNumber: '+374 99 223344',
      address: 'Sayat Nova 10, Yerevan',
      assignedTo: 'Aghavan Dashtsyan',
      priority: '',
      status: 'closedWon',
    },
  ],
};

const MyLeads = () => {
  const [activeTab, setActiveTab] = useState('myLeads');
  const [columns, setColumns] = useState(initialColumns);

  const stats = {
    totalLeads: 6500,
    totalConverted: 8900,
    totalValue: '678,878 AMD',
    conversionRate: '50%',
  };

  return (
    <Container>
      <Header>
        <Title>My Leads</Title>
      </Header>

      <Tabs activeTab={activeTab} onTabChange={setActiveTab} />

      <StatsCards stats={stats} />

      <ContentWrapper>
        <KanbanBoard columns={columns} setColumns={setColumns} />
      </ContentWrapper>
    </Container>
  );
};

export default MyLeads;
